import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import MemberActivityContent from "modules/MemberActivity";

import React from "react";

import { setTitle } from "utilities/helper/setTitle";

const MemberActivityPage: React.FC = () => {
  setTitle("Membership List");
  return (
    <Auth>
      <Layout>
        <MemberActivityContent />
      </Layout>
    </Auth>
  );
};

export default MemberActivityPage;
